import { render, staticRenderFns } from "./KimsaGallery.vue?vue&type=template&id=d9cf9510&scoped=true&"
import script from "./KimsaGallery.vue?vue&type=script&lang=js&"
export * from "./KimsaGallery.vue?vue&type=script&lang=js&"
import style0 from "./KimsaGallery.vue?vue&type=style&index=0&id=d9cf9510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cf9510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
